import {
  AutoFillFormTypeEnum,
  AutoFillAssistantInputItem,
} from 'libs/gb-dashboard/shared/data-access-ai/src/lib/+state/ai.models'
import { SetupGuideAiMessage, SetupGuideAiMessageTypeEnum } from '../types/ai-chat.types'

export function buildAutoFillMessagesHistory(
  messages: SetupGuideAiMessage[],
  formType: AutoFillFormTypeEnum | null | undefined,
): AutoFillAssistantInputItem[] | undefined {
  if (formType !== AutoFillFormTypeEnum.BrandingSettings) {
    return undefined
  }

  return messages.reduce<AutoFillAssistantInputItem[]>((history, message) => {
    if (message.type === SetupGuideAiMessageTypeEnum.User) {
      history.push({
        type: 'message',
        role: 'user',
        content: message.content,
      })
      return history
    }

    if (message.type === SetupGuideAiMessageTypeEnum.Assistant || message.type === SetupGuideAiMessageTypeEnum.Error) {
      if (message.content === 'Processing your request...') {
        return history
      }
      history.push({
        type: 'message',
        role: 'assistant',
        content: message.content,
      })
      return history
    }

    if (message.type === SetupGuideAiMessageTypeEnum.ToolCall) {
      if (!message.callId || !message.toolName) {
        return history
      }

      history.push({
        type: 'function_call',
        call_id: message.callId,
        name: message.toolName,
        arguments: getJsonStringOrFallback(message.toolArguments, '{}'),
      })
      return history
    }

    if (message.type === SetupGuideAiMessageTypeEnum.ToolResult) {
      if (!message.callId || !message.toolContent) {
        return history
      }

      const outputWords = JSON.stringify(message.toolContent).split(/\s+/)
      const truncatedOutput =
        outputWords.length > 100
          ? outputWords.slice(0, 100).join(' ') + ' <function_call_output_here_truncated_for_optimization>'
          : outputWords.join(' ')

      history.push({
        type: 'function_call_output',
        call_id: message.callId,
        output: truncatedOutput,
      })
    }

    return history
  }, [])
}

export function getJsonStringOrFallback(value: string | undefined, fallback: string): string {
  if (!value) {
    return fallback
  }

  try {
    const parsed: unknown = JSON.parse(value)
    return JSON.stringify(parsed)
  } catch {
    return fallback
  }
}

export function generateChatMessageId(): string {
  return `${Date.now()}-${Math.random().toString(16).slice(2, 10)}`
}
